export const shippingMethodLcProps = () => ({
  service: {
    type: Object,
    required: false,
    default: null
  },
  modeCommande: {
    type: Object,
    required: true
  },
  addresseLad: {
    type: Object,
    required: false
  },
  idAddressLivraison: {
    type: [Number, String],
    required: false,
    default: null
  },
  infosPossibleServices: {
    type: [Array, Object],
    required: true
  }
})

export const useShippingMethodLc = (props, raisonsIndispoRef) => {
  const serviceSelectedId = ref(null)
  const serviceModel = ref(null)
  const raisonsImpossible = ref(null)

  const partenaires = computed(() => {
    return props.modeCommande.services;
  })
  const selectedService = computed(() => {
    if (serviceSelectedId.value) {
      return partenaires.value.find(p => { return p.id === serviceSelectedId.value });
    }
    return null;
  })

  const mounted = () => {
    if (partenaires.value.length === 1) {
      serviceModel.value = partenaires.value[0];
    } else if (props.service) {
      serviceModel.value = props.service;
      serviceSelectedId.value = props.service.id
    }
  }
  const resetService = () => {
    serviceModel.value = null;
  }
  const isServiceDisabled = (service) => {
    return props.infosPossibleServices[service.id] ? (props.infosPossibleServices[service.id].possible === false) : true
  }
  const getTarifMini = (service) => {
    return props.infosPossibleServices[service.id] ? props.infosPossibleServices[service.id].tarif_mini_txt : null;
  }
  const showRaisonsIndispo = (service) => {
    raisonsImpossible.value = props.infosPossibleServices[service.id].raisons;
    raisonsIndispoRef.value.show();
  }

  watch(
    () => props.service,
    (val) => { serviceModel.value = val; },
    { immediate: true }
  )

  return {
    serviceSelectedId,
    serviceModel,
    raisonsImpossible,
    partenaires,
    selectedService,
    mounted,
    resetService,
    isServiceDisabled,
    getTarifMini,
    showRaisonsIndispo
  }
}